export default __webpack_public_path__ + "static/media/about1.4fd85e27.png";